import { findSize } from './clean-department-utils'
import _ from 'lodash'

export function cleanEntityRequirements (entity, department, menuBlob) {
  if (!_.has(entity, 'requirements')) {
    return
  }

  const availableRequirements = _.get(menuBlob, 'requirements', []).map(it => it.id)
  entity.requirements = entity.requirements.filter(({ id }) => availableRequirements.includes(id))
  entity.requirements
    .filter(it => it.selected)
    .sort((a, b) => a.order - b.order)
    .forEach((it, i) => (it.order = i))

  const availableOptions = _.get(findSize(department), 'options', []).map(it => it.id)

  for (const requirement of entity.requirements) {
    requirement.excludeSizes = requirement.excludeSizes.filter(id => availableOptions.includes(id))
  }
}
